import React from 'react';
import { Container } from '@fiverr-private/layout_components';
import type { Types } from '@fiverr-private/theme';

interface RollupAnimationBackProps {
  handleHeight: number;
  backgroundColor?: Types.SelectorBackgroundColorsType;
}

export const RollupAnimationBack = ({
  children,
  handleHeight,
  backgroundColor,
}: React.PropsWithChildren<RollupAnimationBackProps>) => (
  <Container
    position="absolute"
    top={0}
    left={0}
    width="100%"
    height="100%"
    display="flex"
    backgroundColor={backgroundColor}
    zIndex="1"
    style={{ paddingTop: `${handleHeight}px` }}
  >
    {children}
  </Container>
);
